import { useMutation, useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLeadsResponse } from "../models/Lead";
import apiConfig from "../utils/apiConfig";

export default function useLeadByVehicleId(componentName = "useLeadByVehicleId", vehicleId: string) {
  const { get } = useApiHelper(apiConfig(componentName));

  const lead = useQuery({
    queryKey: ["lead", componentName],
    queryFn: () => get<IAllLeadsResponse>(`/lead/partialbyvehicle?vehicleId=${vehicleId}`),
  });

  return {
    lead,
  };
}
